import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-user-status-cell',
  standalone: true,
  imports: [NgIf],
  template: `
    <span class="status-badge"
          [class.status-active]="data?.status === 'ACTIVE'"
          [class.status-pending]="data?.status === 'PENDING'"
          [class.status-disabled]="data?.status === 'DISABLED'">
      {{ data?.statusLabel || '—' }}
    </span>
    <div *ngIf="data?.status === 'PENDING' && data?.invitationExpired" class="status-hint">Invitation expirée</div>
  `,
  styles: [`
    .status-badge {
      display: inline-block;
      padding: 2px 10px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 600;
      white-space: nowrap;
    }
    .status-active { background: #e6f6ec; color: #1e7b45; }
    .status-pending { background: #fff4e0; color: #9a5b00; }
    .status-disabled { background: #fdecec; color: #b42318; }
    .status-hint { font-size: 11px; color: #b42318; margin-top: 2px; }
  `],
})
export class UserStatusCellComponent {
  @Input() data: any;
  @Input() column: any;
}
